<template>
  <div class="table-wraper">
    <v-loading :active="loading || locking" :is-full-page="false"></v-loading>
    <template v-if="!loading">
      <template v-if="stockData.content.length">
        <el-table
          class="stock-table"
          border
          :data="stockData.content"
          max-height="400"
        >
          <el-table-column
            width="280"
            align="center"
            fixed="left"
            label="舱房/库存"
          >
            <template #default="{row}">
              <p>{{ row.name }}（总：{{ row.stock }}）</p>
              <p>
                已确认：{{ row.confirm_num
                }}<v-divider direction="vertical" />占位中：{{ row.seize_num
                }}<v-divider direction="vertical" />余：{{ row.last_stock }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(name, columnIndex) in stockData.title"
            :key="columnIndex"
            min-width="160"
            :label="name"
            align="center"
          >
            <template #default="{row}">
              <!-- {{columnIndex}}  -->
              <p>已确认：{{ row.list[columnIndex].confirm_num }}</p>
              <p>占位中：{{ row.list[columnIndex].seize_num }}</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="actions">
          <el-button type="primary" @click="handleExport">导出</el-button>
        </div>
      </template>
      <template v-else>
        <v-no-data />
      </template>
    </template>
  </div>
</template>

<script>
import {
  getProductAllianceStock,
  exportProductAllianceStock
} from "~/services/product";
// import DownloadByUrl from '@/utils/file-download'
// import {stringify} from '@/utils/qs.js'
// import {API_BASIC} from '@/config/index.js'
import {
  // MESSAGE_TYPES,
  // NOTIFY_GROUPS,
  REQUEST_CODES
} from "@/constants/const-http";

function createDefaultStockData() {
  return {
    product_name: "",
    title: [],
    content: []
  };
}

export default {
  props: {
    productNo: {
      type: [String, Number],
      default: "",
      required: true
    },
    spdId: {
      type: [String, Number],
      default: "",
      required: true
    },
    dialogTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      locking: false,
      stockData: createDefaultStockData()
    };
  },
  // computed: {
  //   exportUrl(){
  //     return '/api' +  productApi.exportAllianceExcel + stringify({
  //       product_no: this.productNo,
  //       spd_id: this.productNo
  //     }, {addQueryPrefix: true})
  //   }
  // },
  async created() {
    this.loading = true;
    let { code, data, msg } = await getProductAllianceStock({
      product_no: this.productNo,
      spd_id: this.spdId
    });
    this.loading = false;
    if (code !== REQUEST_CODES.ERROR_OK) {
      this.$message.error(msg);
      this.stockData = createDefaultStockData();
      return;
    }
    this.stockData = data;
    this.$emit("update:dialogTitle", data.product_name);
  },
  methods: {
    async handleExport() {
      this.locking = true;
      try {
        let { data, code, msg } = await exportProductAllianceStock({
          product_no: this.productNo,
          spd_id: this.spdId
        });
        if (code !== REQUEST_CODES.ERROR_OK) {
          this.$message.error(msg);
          return;
        }
        window.open(data.url);
        // DownloadByUrl(data.url, `${Date.now()}.xlsx`)
        this.locking = false;
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>

// @import "~@/assets/scss/base/public.scss";
.table {
  &-wraper {
    // overflow: auto;
    max-height: 600px;
    min-height: 300px;
  }
  td,
  th {
    white-space: nowrap;
  }
  th {
    background-color: $color-grey-8;
  }
}

// ::v-deep {
//   .stock-table {
//     .head-col {
//       div:first-child {
//         text-align: right;
//       }
//       div:last-child {
//         text-align: left;
//       }

//       &::before {
//         content: "";
//         position: absolute;
//         left: 0;
//         right: 0;
//         top: 0;
//         bottom: 0;
//         background: url($slash-img) no-repeat 100% center;
//       }
//     }
//   }
// }

.actions {
  text-align: right;
  margin-top: 20px;
}

</style>
